import { render, staticRenderFns } from "./ServeSale202301NotFree.vue?vue&type=template&id=64cb17cf&scoped=true"
import script from "./ServeSale202301NotFree.vue?vue&type=script&lang=js"
export * from "./ServeSale202301NotFree.vue?vue&type=script&lang=js"
import style0 from "./ServeSale202301NotFree.vue?vue&type=style&index=0&id=64cb17cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb17cf",
  null
  
)

export default component.exports